export default class MegaMenu {
    constructor(component) {
        this.component = component;
        // Get container for scope
        this.menuTrigger = document.querySelector(`[aria-controls="${component.id}"]`);
        // Get all elements with aria-expanded
        this.triggers = this.component.querySelectorAll('[aria-expanded]');

        this.init();
    }

    _setAttributeForAll(items, name, value) {
        items.forEach((item) => {
            item.setAttribute(name, value);
        });
    }

    _setMenuHeight() {
        const submenus = Array.from(this.component.querySelectorAll('.bu-header-nav__submenu'));

        submenus.forEach((submenu) => {
            this.component.style.minHeight =
                this.component.scrollHeight < submenu.scrollHeight
                    ? `${submenu.scrollHeight}px`
                    : `${this.component.scrollHeight}px`;
            submenu.classList.add('height-100');
        });
    }

    _observeChange() {
        const observer = new MutationObserver(() => {
            if (this.menuTrigger.getAttribute('aria-expanded') === 'true') {
                const firstLink = this.component.querySelector('.bu-header__link');
                firstLink.setAttribute('aria-expanded', 'true');
            } else {
                const allLinks = this.component.querySelectorAll('.bu-header__link');
                allLinks.forEach((link) => {
                    link.setAttribute('aria-expanded', 'false');
                });
            }
        });

        observer.observe(this.menuTrigger, {
            attributeFilter: ['aria-expanded'],
        });
    }

    init() {
        // Set eventhandler for every trigger
        this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                // Check expanded status
                const status = trigger?.getAttribute('aria-expanded');
                // If aria-expanded=false
                if (status) {
                    // Set all other triggers to aria-expanded=false
                    this._setAttributeForAll(this.triggers, 'aria-expanded', false);
                    // Set current trigger to aria-expanded=true
                    trigger.setAttribute('aria-expanded', 'true');
                }
            });
        });

        this._observeChange();
        this._setMenuHeight();
    }
}
